import React from 'react';
import PlayerAvatar from './PlayerAvatar';
import Skeleton from '@mui/material/Skeleton';
import { MaterialThemeProvider } from '../../context/ThemeProvider';
import useApi from '../../hook/useApi';

export const Leaderboard = () => {
  const { data: leaders, loading } = useApi(
    'GET',
    'player/leaders',
    undefined,
  );

  return (
    <MaterialThemeProvider>
      <div className="leaderboard-box">
        <h4>Token Leaderboard</h4>

        <div className="leaderboard-header">
          <div className="leaderboard-header-name">Name</div>
          <div className="leaderboard-header-token">Tokens</div>
          <div className="leaderboard-header-wallet">Wallet</div>
        </div>

        <div style={{ flex: 1, width: "100%" }}>
          {!loading && leaders?.length > 2 ? (
            leaders.map((item, index) => {
              const shortAddress = item.smartAccount.slice(0, 5) + '...' + item.smartAccount.slice(-4);
              const formatted = new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(item.tokens);

              return (
                <div key={index} className="leaderboard-item">
                  <div className='leaderboard-avatar'>
                    <PlayerAvatar avatarId={item.playerAvatar} />
                  </div>
                  <span className="leaderboard-name">{item.playerName}</span>
                  <div className="leaderboard-token">{`${formatted} ZTGM`}</div>
                  <div className="leaderboard-wallet">
                    <a href={`https://sepolia.arbiscan.io/address/${item.smartAccount}`} target="_blank" rel="noopener noreferrer">
                      {shortAddress}
                    </a>
                  </div>
                </div>
              )
            })
          ) : (
            Array.from(new Array(5)).map((_, index) => (
              <div key={index} className="skelaton-item">
                <Skeleton animation="wave" variant="circular" width={40} height={40} />
                <Skeleton
                  animation="wave"
                  height={10}
                  width="90%"
                  style={{ margin: "5px" }}
                />
              </div>
            ))
          )}
        </div>
      </div >
    </MaterialThemeProvider>
  )
}